<template>
    <div class="modal fade" id="uk-modal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="uk-modal__content">
                        <div class="uk-modal__body">
                            <div class="uk-modal__flag">
                                <i class="flag-icon flag-icon-en"></i>
                            </div>

                            <div class="uk-modal__headline">
                                {{ $translate('OD3dprimaV2::Template.ukModalHeadline') }}
                            </div>

                            <div class="uk-modal__subheadline">
                                {{ $translate('OD3dprimaV2::Template.ukModalSubheadline') }}

                            </div>
                        </div>

                        <div class="uk-modal__footer">
                            <a :href="$translate('OD3dprimaV2::Template.ukModalToWebsiteLink')" target="_blank"
                                class="btn btn-primary">
                                <i class="flag-icon flag-icon-en"></i>
                                {{ $translate('OD3dprimaV2::Template.ukModalToWebsiteBtn') }}
                            </a>

                            <span @click="closeModal()" class="btn btn-primary-outline">
                                <i class="flag-icon flag-icon-eu"></i>
                                {{ $translate('OD3dprimaV2::Template.ukModalContinueBtn') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    mounted() {
        if (getCookie('customer_type_country') === "true" && getCookie('ignore_uk_info') === null && (this.localization.shippingCountryId === 12 || this.localization.shippingCountryId === 148 || this.localization.shippingCountryId === 150 || this.localization.shippingCountryId === 136)) {
            $("#uk-modal").modal("show")
        }
    },
    computed: {
        ...mapState({
            localization: state => state.localization,
        }),
    },
    methods: {
        closeModal() {
            setCookie('ignore_uk_info', true);
            $("#uk-modal").modal("hide")
        }
    }
}
</script>